import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

const Metatags = ({ metatags }) => {
  if (metatags === null) {
    return null;
  }
  const meta = metatags.filter(tag => tag.tag === 'meta');
  const regularMeta = [];
  const schema = [];
  let title = '';
  meta.forEach((tag) => {
    if (tag.attributes.schema_metatag) {
      schema.push(tag.attributes);
    } else if (tag.attributes.name === 'title') {
      title = tag.attributes.content;
    } else {
      regularMeta.push(tag.attributes);
    }
  });
  const formattedSchema = {
    '@context': 'https://schema.org',
    '@graph': [],
  };
  const groups = {};
  schema.forEach((item) => {
    if (!(item.group in groups)) {
      groups[item.group] = {};
    }
    groups[item.group][item.name] = item.content;
  });
  if ('schema_organization' in groups) {
    groups.schema_organization.aggregateRating = {
      '@type': 'AggregateRating',
      ratingValue: 4.9,
      ratingCount: 205,
    };
  }
  Object.keys(groups).forEach(group => formattedSchema['@graph'].push(groups[group]));
  return (
    <Head>
      {title.length > 0 && <title>{title}</title>}
      {regularMeta.map(tag => <meta {...tag} key={Math.random()} />)}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(formattedSchema) }}
      />
    </Head>
  );
};

Metatags.propTypes = {
  metatags: PropTypes.arrayOf(PropTypes.shape({})),
};

Metatags.defaultProps = {
  metatags: null,
};

export default Metatags;
